import React, { Component } from 'react';
import _ from 'lodash';
import atob from 'atob';
import { Container, Segment, Button, Table, List, Popup, Label } from 'semantic-ui-react';


import { getUserDisplayNameFromEmail } from '../../../helpers/format';
import { base } from '../../../config/constants';
import { AlertBox, ConfirmBox, setAlertMsg, askConfirmation } from '../../../components/Modals';

const getTypeLabel = (habilitations) => {
  if (!habilitations) {
    return '';
  }
  if (habilitations && habilitations.superuser) {
    return (<Label color="red">Super Administrateur</Label>);
  }
  if (habilitations) {
    return (<Label color="blue">Émetteur</Label>);
  }
  return 'N/A';
};

const getFormattedList = (themes) => {
  if (!themes || Object.keys(themes).length < 1) {
    return '-';
  }

  const themesList = Object.keys(themes);

  return (
    <Popup
      trigger={<Label>{themesList.length}</Label>}
      position="right center"
      // inverted
    >
      <List>
        {
          _.map(themesList, theme => (
            <List.Item key={theme}>
              <List.Content>
                {theme.toUpperCase()}
              </List.Content>
            </List.Item>
          ))
        }
      </List>
    </Popup>
  );
};

export default class ListPreregistrations extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // selectedAdmin: null,
      preinscriptionsLoading: true,
      preinscriptions: [],
    };
  }

  componentDidMount() {
    base.bindToState('adminPreinscriptions', {
      context: this,
      state: 'preinscriptions',
      asArray: true,
      then() {
        this.setState({ preinscriptionsLoading: false });
        // console.log(this.state.preinscriptions);
      },
      onFailure(error) {
        // console.log('error');
        this.setState(setAlertMsg(
          null,
          'Impossible de récupérer la liste des préinscriptions',
          error.toString(),
          'error',
        ));
      },
    });
  }

  getUserLabelContent = (email, key) => {
    if (!email) {
      return null;
    }
    return (
      <Popup
        trigger={
          <Button
            animated="fade"
            fluid
            size="tiny"
            onClick={
              () => this.handleCancelPreregistration(email, key)
            }
          >
            <Button.Content visible>
              {getUserDisplayNameFromEmail(email)}
            </Button.Content>
            <Button.Content hidden>
              Supprimer
            </Button.Content>
          </Button>
        }
      >
        <Popup.Content>{email}</Popup.Content>
      </Popup>
    );
  };

  handleCancelPreregistration = (email, key) => {
    // console.log('handleCancelPreregistration for (email, key)', email, key);
    this.setState(askConfirmation(
      'Supprimer une préinscription',
      `Vous allez annuler la préinscription de l'utilisateur suivant:<br/><br/>
       <strong>${getUserDisplayNameFromEmail(email)}</strong><br/>${email}<br/><br/>
       Voulez-vous vraiment supprimer cette préinscription ?`,
      'destructive',
      () => {
        base.remove(`adminPreinscriptions/${key}`).catch((error) => {
          this.setState(setAlertMsg(
            error.code || null,
            'Impossible de supprimer cette préinscription',
            error.toString(),
            'error',
          ));
        });
      },
      'OUI, SUPPRIMER',
    ));
  }

  render() {
    return (
      <Container>
        <Segment basic loading={this.state.preinscriptionsLoading}>
          <Table
            compact
            selectable
            stackable
            // sortable
            tableData={this.state.preinscriptions}
            headerRow={
              <Table.Row>
                <Table.HeaderCell>
                  Identifiant
                </Table.HeaderCell>
                <Table.HeaderCell>Type</Table.HeaderCell>
                <Table.HeaderCell>Professions</Table.HeaderCell>
                <Table.HeaderCell>Communes</Table.HeaderCell>
                <Table.HeaderCell>Circonscriptions</Table.HeaderCell>
              </Table.Row>
            }
            footerRow={this.state.preinscriptions.length === 0 ?
              (
                <Table.Row>
                  <Table.Cell colSpan={5} textAlign="center" disabled>
                    <Segment basic padded="very">
                      Aucune préinscription en attente
                    </Segment>
                  </Table.Cell>
                </Table.Row>
              ) : null}
            renderBodyRow={data => (
              <Table.Row key={data.key}>
                <Table.Cell>
                  {this.getUserLabelContent(atob(data.key), data.key)}
                </Table.Cell>
                <Table.Cell>
                  {getTypeLabel(data.habilitations)}
                </Table.Cell>
                <Table.Cell>
                  {
                    data.habilitations && data.habilitations.themes
                      ? getFormattedList(data.habilitations.themes) : null
                  }
                </Table.Cell>
                <Table.Cell>
                  {
                    data.habilitations && data.habilitations.citizenly
                      ? getFormattedList(data.habilitations.citizenly) : null
                  }
                </Table.Cell>
                <Table.Cell>
                  {
                    data.habilitations && data.habilitations.elected
                      ? getFormattedList(data.habilitations.elected) : null
                  }
                </Table.Cell>
              </Table.Row>
            )}
          />
        </Segment>
        <AlertBox
          propagateClosure={() => this.setState({ alert: { open: false } })}
          {...this.state.alert}
        />
        <ConfirmBox
          propagateClosure={() => this.setState({ confirm: { open: false } })}
          {...this.state.confirm}
        />
      </Container>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/protected/AccessManagement/ListPreregistrations.js